import { Component, forwardRef, ViewChild, AfterViewInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { IntegerValueAccessorDirective } from '../../../shared/directives/integer-value-accessor.directive';

@Component({
  selector: 'app-treatment-count-input',
  templateUrl: './treatment-count-input.component.html',
  providers: [{
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TreatmentCountInputComponent),
      multi: true
    }]
})
export class TreatmentCountInputComponent implements AfterViewInit, ControlValueAccessor {

  @ViewChild(IntegerValueAccessorDirective) valueAccessor: IntegerValueAccessorDirective;

  ngAfterViewInit(): void {
    this.valueAccessor.writeValue(this.value);
    this.valueAccessor.registerOnTouched(() => { });
    this.valueAccessor.registerOnChange((v) => {
      this.value = v;
    });
  }

  
  private value: number;
  private onChange = (value) => {};
  private onTouched = () => {};
  
  constructor() { }
  
  public apply(): void {
    this.onChange(this.value);
    this.onTouched();
  }

  writeValue(obj: any): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  
  setDisabledState?(isDisabled: boolean): void {
    if (this.valueAccessor.setDisabledState) {
      this.valueAccessor.setDisabledState(isDisabled);
    }
  }

}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/treatment-count-input/treatment-count-input.component.ts